<template>
  <a-modal
      title="选择采购品目"
      :visible="visible"
      @ok="handleOk"
      :maskClosable="false"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
      :width="1300"
  >
    <div style="float: right" class="mr-4">
      <a-button type="primary" icon="swap" @click="switchingSearch">
        {{ switchingSearchFlag ? '关闭搜索' : '打开搜索' }}
      </a-button>
    </div>
    <template v-if="!switchingSearchFlag">
    <a-radio-group v-model="defaultParam.fspmbm" @change="onSelectChange($event.target.value, defaultParam.level)"
                   button-style="solid" size="large"
                   style="margin-bottom: 20px">
      <a-radio-button value="A">
        货物类
      </a-radio-button>
      <a-radio-button value="B">
        工程类
      </a-radio-button>
      <a-radio-button value="C">
        服务类
      </a-radio-button>
    </a-radio-group>
    <a-row type="flex" :gutter="12">
      <a-col :span="6" v-for=" itemInfo in purchaseItem ">
        <span>{{ itemInfo.name }}</span>
        <div class="zdy_ul_box">
          <ul class="zdy_ul" v-if="itemInfo.data && itemInfo.data.length>0">
            <li :class="dataInfo.active?'active':''"
                v-for="dataInfo in itemInfo.data ">
              <a-radio :checked="dataInfo.checked"
                       :disabled="dataInfo.nextLevelNumber>0 && itemInfo.level === purchaseItem[0].level"
                       @change="onCheckedChange($event.target.checked,dataInfo.fspmbm,dataInfo.fspmmc)"></a-radio>
              <template v-if="itemInfo.level<purchaseItem[3].level  && dataInfo.nextLevelNumber">
                <span @click="onSelectChange(dataInfo.fspmbm,itemInfo.level)">{{ dataInfo.fspmmc }}</span>
                <a-icon type="right"/>
              </template>
              <span v-else>{{ dataInfo.fspmmc }}</span>
              <template v-if="dataInfo.expertNumber">
                <small>{{ dataInfo.expertNumber }}</small>
              </template>
            </li>
          </ul>
          <a-empty v-else/>
        </div>
      </a-col>
    </a-row>
    </template>
    <search-purchase-item ref="searchPurchaseItemRef" v-show="switchingSearchFlag" row-selection-type="radio"
                          :user-select-content="userSelectContent"
                          @syncUserSelectContent="onuSyncUserSelectContent"/>
    <div>
      已选择品目：
      <a-button-group size="small" class="ml-2 mt-2" v-for="(item) in userSelectContent">
        <a-button>{{ item.fspmmc }}</a-button>
        <a-button @click="removeMethod(item)" type="danger">
          <a-icon type="delete"></a-icon>
        </a-button>
      </a-button-group>
    </div>
  </a-modal>
</template>
<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { GetNextLevelItemListToAgent, GetNextLevelItemList } from '@/epp/expertmain/purchaseitems/PurchaseRequest'
import { GetExpertNumByItemCode } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import SearchPurchaseItem from '@/epp/expertmain/purchaseitems/SearchPurchaseItem.vue'

export default {
  name: 'ChooseRedrawPurchaseItemV2',
  components: {
    SearchPurchaseItem,
    PageView,
    STable
  },
  mounted () {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyId: {
      type: String,
      default: undefined
    },
  },
  data () {
    return {
      userSelectContent: [],//用户勾选的内容
      confirmLoading: false,
      defaultParam: {
        fspmbm: 'A',
        level: 0
      },
      purchaseItem: [
        {
          name: '一级品目',
          level: 1,
          data: []
        },
        {
          name: '二级品目',
          level: 2,
          data: []
        },
        {
          name: '三级品目',
          level: 3,
          data: []
        },
        {
          name: '四级品目',
          level: 4,
          data: []
        },

      ],
      limitNum: 0,
      expertItem: {},
      switchingSearchFlag: false,
    }
  },
  created () {
  },
  methods: {
    //数据回显
    async preView (json, item) {
      let that = this
      this.userSelectContent = json && [...json]
      that.defaultParam = {
        fspmbm: 'A',
        level: 0
      }
      this.expertItem = item
      await this.getItemData(this.defaultParam)
    },
    //确认后数据传回调用方
    handleOk () {
      this.$emit('success', this.userSelectContent)
    },
    //关闭窗口
    handleCancel () {
      this.$emit('cancel')
    },
    //获取下一级品目数据
    async getItemData (queryData) {
      try {
        queryData.applyId = this.applyId
        let res = await GetNextLevelItemList(queryData)
        if (200 === res.code) {
          //设置默认选中状态
          res.result.map(item => {
            item.checked = false
            item.active = false
          })
          this.purchaseItem[queryData.level].data = res.result
          //清除该阶级后面的数据
          for (let i = queryData.level + 1; i < this.purchaseItem.length; i++) {
            this.purchaseItem[i].data = []
          }
          //设置选中状态
          this.purchaseItem[queryData.level].data.map(item => {
            let selectedItem = this.userSelectContent.filter(item2 => item2.fspmbm === item.fspmbm)[0]
            if (selectedItem) {
              this.handleSelectState(true, selectedItem)
            }
          })
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
      }
    },
    //处理文字选中状态
    async onSelectChange (code, level) {
      await this.getItemData({
        fspmbm: code,
        level: level
      })
      if (level > 0) {
        this.purchaseItem[level - 1].data.map(item => {
          item.active = item.fspmbm === code
        })
      }
    },
    //处理单选框选中状态
    async onCheckedChange (checked, code, codeName) {
      let that = this
      //清除
      for (let i = 0; i < this.purchaseItem.length; i++) {
        this.purchaseItem[i].data.map(item => {
          item.checked = item.fspmbm === code
          if (item.checked) {
            that.userSelectContent = [item]
            //同步copyData
            this.$refs.searchPurchaseItemRef?.syncCopyData(that.userSelectContent)
          }
        })
      }
      //选择前获取该品目的专家数量
      if (checked) {
        let { address, otherSourceLibrary, specificProfessionalTitleKey } = this.expertItem
        const params = {
          areaAddress: address,
          otherSourceLibrary: otherSourceLibrary,
          specificProfessionalTitleKey: specificProfessionalTitleKey,
          selectPurchaseItemCode: code,
          applyId: this.applyId
        }
        let res = await GetExpertNumByItemCode(params)
        this.$info({
          title: '提示',
          content: `品目【${codeName}】可用专家数量为${res.result}`
        })
      }
    },
    removeMethod (data) {
      this.userSelectContent = this.userSelectContent.filter(item => item.fspmbm !== data.fspmbm)
      //移除选中状态
      this.handleSelectState(false, data)
    },
    //处理选中状态
    handleSelectState (checked, data) {
      this.purchaseItem.map(item => {
        item.data.map(item2 => {
          if (item2.fspmbm === data.fspmbm) {
            item2.checked = checked
          }
        })
      })
    },
    //处理选中状态,设置未选中
    handleSelectState2 (data) {
      this.purchaseItem.map(item => {
        item.data.map(item2 => {
          item2.checked = item2.fspmbm === data.fspmbm
        })
      })
    },
    //切换搜索
    switchingSearch () {
      this.switchingSearchFlag = !this.switchingSearchFlag
      //重置搜索页数据
      if (this.switchingSearchFlag){
        this.$refs.searchPurchaseItemRef?.onReSet()
      }
    },
    //同步用户选择品目
    onuSyncUserSelectContent (userSelectContent) {
      userSelectContent = userSelectContent || []
      this.userSelectContent = [...userSelectContent]
      if (userSelectContent.length === 0) {
        this.handleSelectState2()
        return
      }
      userSelectContent.forEach(item => {
        this.handleSelectState2(item)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}

/deep/ .ant-empty {
  margin: 90px 8px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.close-span:hover {
  cursor: pointer;
}
</style>
